import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const FeatureFlagApi = {
  getFeatureFlags: (
    action: {
      page: number;
      limit: number;
      searchCode?: string;
      activeOnly?: boolean;
    },
    dispatch: Dispatch
  ) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }

    return AxiosClient.post('/featureflag/v1/read' + (queryParams ? `?${queryParams}` : ''), {
      featureFlags: [],
      activeOnly: action.activeOnly,
    })
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.FeatureFlagsKey
        );
      });
  },

  createFeatureFlag: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/featureflag/v1/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  updateFeatureFlag: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/featureflag/v1/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  deleteFeatureFlags: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/featureflag/v1/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  getFeatureFlagDetails: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/featureflag/v1/read', {
      featureFlags: action.request,
      activeOnly: false,
    })
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },
};
